export default {
  newWorkspaceId: state => state.newWorkspaceId,
  allWorkspacesLength: state => state.workspacesList.length,
  allWorkspaces: state => state.workspacesList,
  isLoading: state => state.isLoading
}
